import { Observable } from 'rxjs'

// Minimal rxjs wrappers around the firebase compat onSnapshot/onAuthStateChanged
// APIs. Replaces the `rxfire` dependency, whose modern (v6+) releases target the
// modular firebase SDK and are incompatible with the compat query/ref objects
// used throughout the services layer.

// Emits the array of document snapshots for a collection query on every change.
export const collection = query =>
  new Observable(subscriber =>
    query.onSnapshot(
      snapshot => subscriber.next(snapshot.docs),
      error => subscriber.error(error)
    )
  )

// Emits the document snapshot for a single doc reference on every change.
export const doc = reference =>
  new Observable(subscriber =>
    reference.onSnapshot(
      snapshot => subscriber.next(snapshot),
      error => subscriber.error(error)
    )
  )

// Emits the current user (or null) whenever the auth state changes.
export const authState = auth =>
  new Observable(subscriber =>
    auth.onAuthStateChanged(
      user => subscriber.next(user),
      error => subscriber.error(error)
    )
  )
